<template>
    <b-container fluid>
        <b-card>
            <b-form>
                <b-form-group
                    horizontal
                    label="Created by: "
                    label-cols="0"
                    label-cols-sm="2"
                    label-align-sm="right"
                >
                    <b-form-input
                        id="created-by"
                        :value="authorInfo()"
                        readonly
                        type="text"
                    />
                </b-form-group>

                <b-form-group
                    horizontal
                    label="Message Text:"
                    label-for="message-text"
                    label-cols="0"
                    label-cols-sm="2"
                    label-align-sm="right"
                >
                    <b-form-input
                        id="message-text"
                        v-model="form.message_text"
                        type="text"
                    />
                </b-form-group>

                <b-form-group
                    horizontal
                    label="Message Color:"
                    label-for="variant"
                    label-cols="0"
                    label-cols-sm="2"
                    label-align-sm="right"
                >
                    <b-form-select
                        id="variant"
                        v-model="form.variant"
                        :options="variants"
                        :variant="form.variant"
                    />
                </b-form-group>

                <!--
                <b-form-group
                    v-b-popover.hover.top="'Click the button to make announcement active.'"
                    horizontal
                    label="Make Active:"
                    label-cols="0"
                    label-cols-sm="2"
                    label-align-sm="right"
                >
                    <b-form-checkbox
                        v-model="form.active"
                        button
                        inline
                        name="check-button"
                        :active="form.active"
                        active-class="active"
                    >
                        Announcement is <b>{{ form.active ? '' : 'not' }} active.</b>
                    </b-form-checkbox>
                </b-form-group>
                -->
                <v-button
                    prevent-default
                    @click="createAnnouncement"
                >
                    <fa-icon :icon="['fas', 'bullhorn']" /> Create
                </v-button>
            </b-form>
        </b-card>
    </b-container>
</template>


<script>
import { alertManager } from '~/plugins/alertManager';
import { mapGetters } from 'vuex';

export default {
    name: 'AnnouncementCreate',

    data() {
        const now = new Date();
        const today = Date(now.getFullYear(), now.getMonth(), now.getDay());

        const variants = [
            { value: null, text: 'Please select an option' },
            { value: 'primary', text: 'Purple' },
            { value: 'success', text: 'Green' },
            { value: 'warning', text: 'Yellow' },
            { value: 'danger', text: 'Red' },
            { value: 'info', text: 'Blue' },
            { value: 'light', text: 'White' },
            { value: 'secondary', text: 'Light Gray' },
            { value: 'dark', text: 'Dark Gray' }
        ];

        const emptyAnnouncement = {
            message_text: null,
            variant: null,
            active: true,
            author_id: null,
        };

        return {
            form: {
                ...emptyAnnouncement
            },
            // announcement_id: null,
            // message_text: null,
            // variant: null,
            // active: null,
            // active_begin: null,
            // active_end: null,
            // author_id: null,
            // deleted_at: null,
            // created_at: null,
            // updated_at: null,
            author: null,
            today,
            variants,
        };
    },

    computed: {
        ...mapGetters({
            authUser: 'auth/authUser',
            // announcementList: 'announcement/announcementList',
        })
    },

    async created() {
        this.author = await this.authUser;
        // await this.$store.dispatch('announcement/fetchAnnouncementList');
    },

    methods: {
        async createAnnouncement() {
            try {
                await this.$store.dispatch('announcement/createAnnouncement', this.form);
                alertManager.showSuccess({ message: 'Announcement created successfully.' });
            } catch (error) {
                alertManager.showErr(error);
            }
            this.$router.push({ name: 'admin.announcements.AnnouncementList' });
        },

        async createAndClear() {
            await this.createAnnouncement();
            this.form = { ...this.emptyAnnouncement };
            this.author = null;
        },

        authorInfo() {
            return this.author !== null
                ? this.author.fname + ' ' + this.author.lname + '    ' + this.author.email : '';
        },
    },
};
</script>
